import { render, staticRenderFns } from "./fast_order.vue?vue&type=template&id=45ca6d37&scoped=true&"
import script from "./fast_order.vue?vue&type=script&lang=js&"
export * from "./fast_order.vue?vue&type=script&lang=js&"
import style0 from "./fast_order.vue?vue&type=style&index=0&id=45ca6d37&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ca6d37",
  null
  
)

export default component.exports